import { Headers } from '@egw/components'
import { configClient } from '@egw/config'
import { WEALTH_ROUTES } from '@egw/constants'
import { TransferLandingPage } from '@egw/features-transfer'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { Config } from '@wealth/config'
import { type FC } from 'react'
import { Navigate } from 'react-router'

export const AchTransferPage: FC = () => {
  const { t } = useTranslation()

  const config = configClient.getConfig() as Config

  if (config.env === 'demo-dev' || config.env === 'demo-prod') {
    return <Navigate to={WEALTH_ROUTES.OVERVIEW.path} />
  }
  return (
    <Layout>
      <Headers title={t('pages.transfer.title')} />
      <TransferLandingPage />
    </Layout>
  )
}
